var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-inline-block z-component zoezi-menuitem",staticStyle:{"color":"rgb(248, 217, 185)"},on:{"click":_vm.nav}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }